import React, { useState, useEffect, useRef } from "react";
import {
  useParams,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Col,
  Input,
  Row,
  Select,
  Spin,
  Table,
} from "antd";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import {
  getRequest,
  postRequest,
} from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import moment from "moment";
import newLogo from "../../image/PROCEM3.svg";

const VendorPoApproveReject = () => {
  const { t } = useTranslation();
  const { id, token, venId } = useParams();
  const navigate = useNavigate();
  const [rfqHistory, setRFQHistory] = useState([]);
  const [floatId, setFloatId] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoading2, setBtnLoading2] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [searchParams] = useSearchParams();
  const pdfContainerRef = useRef(null);
  const [comparativesRFQ, setComparativesRFQ] = useState([]);
  const [rfqNumber, setRfqNumber] = useState(null);
  const [poTotalAmount, setPoTotalAmount] = useState(0);
  const [apiLoading, setapiloading] = useState(false);
  const [isFreight, setIsFreight] = useState(false);
  const [hasDiameter, setHasDiameter] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const action = queryParams.get("po_status");

  const vendorId1 = searchParams.get("vendor_id");

  const site_name = searchParams.get("site_name");

  const handleDirectRelease = async () => {
    setBtnLoading(true);
    await postRequest(
      "po-order/po-approval-by-vendor/" +
        token +
        "/" +
        `${id}` +
        `/?po_status=OrderAcceptedByVendor&vendor_id=${vendorId1}`
    ).then((response) => {
      navigate("/vendor-purchase-order-summary/");
      SuccessNotificationMsg(response.data.message);
      setBtnLoading(false);
    });
  };

  const handleReject = async () => {
    setBtnLoading2(true);
    await postRequest(
      "po-order/po-approval-by-vendor/" +
        token +
        "/" +
        `${id}` +
        `/?po_status=OrderRejectedByVendor&vendor_id=${vendorId1}`
    ).then((response) => {
      navigate("/rfq-vendor-request-for-quotation/history/1");
      SuccessNotificationMsg(response?.data?.message);
      setBtnLoading2(false);
    });
  };

  useEffect(() => {
    const getVendorBidRFQ = async () => {
      try {
        setapiloading(true);

        if (action === `OrderAcceptedByVendor`) {
          setapiloading(true);
          await postRequest(
            "po-order/po-approval-by-vendor/" +
              token +
              "/" +
              `${id}` +
              `/?po_status=OrderAcceptedByVendor&vendor_id=${vendorId1}`
          )
            .then((response) => {
              navigate("/vendor-purchase-order-summary/");
              SuccessNotificationMsg(response.data.message);
            })
            .catch((response) => {
              ErrorNotificationMsg(response.data.message);
            });
        } else if (action === "OrderRejectedByVendor") {
          setapiloading(true);

          await getRequest(
            `po-order/${id}/purchase-order-vendor-email-response/?vendor_id=${vendorId1}&site_name=${site_name}`
          )
            .then((response) => {
              if (response.data.data) {
                setapiloading(true);
                setRfqNumber(response.data.data.rfq_number);
                setPoTotalAmount(response?.data?.data?.total_amount);
                setFloatId(response.data.data.float_rfq);
                setIsFreight(response.data.data.is_freight_excluded)
                const responseData =
                  response?.data?.data?.purchase_order_city_details;

                setOrderData(response.data.data);

                setRFQHistory(responseData);
                const hasDiameterDetails = responseData?.some(city => 
                  city.purchase_order_site_details?.some(site => 
                    site.po_vendor_detail?.some(vendor => 
                      vendor.po_material_detail?.some(material => 
                        material.diameter_details && material.diameter_details.length > 0
                      )
                    )
                  )
                );
                setHasDiameter(hasDiameterDetails);

                const tableData = responseData?.map((item, index) => {
                  const citySubTotal = item.vendor_city_total.reduce(
                    (acc, amount) => acc + amount.amount_with_gst,
                    0
                  );

                  const citySubTotalWithoutGST = item.vendor_city_total.reduce(
                    (acc, amount) => acc + amount.amount_without_gst,
                    0
                  );

                  return {
                    key: item.po_city_name,
                    cityName: item.po_city_name,
                    citySubTotal: citySubTotal,
                    citySubTotalWithoutGST: citySubTotalWithoutGST,
                    comparative: item.purchase_order_site_details.map(
                      (com, ind) => {
                        const siteSubTotal =
                          com.vendor_site_sub_total[0].amount_without_gst;
                        const siteSubTotalWithGST =
                          com.vendor_site_sub_total[0].amount_with_gst;
                        return {
                          siteName: com.rfq_site_name,
                          siteId: com.rfq_site_id,
                          siteSubTotal: siteSubTotal,
                          siteSubTotalWithGST: siteSubTotalWithGST,
                          vendorWise: com.po_vendor_detail.map((it, index) => {
                            return {
                              vendorName: it.vendor_name,
                              siteLocations: it.po_material_detail.flatMap(
                                (item1, index) => {
                                  if (item1.diameter_details && item1.diameter_details.length > 0) {
                                    const groupedByDiameter = item1.diameter_details.reduce((acc, diameter) => {
                                      const key = `${item1.bid_material_type_name}_${diameter.diameter_value}`;
                                      if (!acc[key]) {
                                        acc[key] = {
                                          materialName: item1.bid_material_type_name,
                                          diameter: diameter.diameter_value,
                                          uom: item1.bid_uom,
                                          quantities: [],
                                          unit_rates: [],
                                          unit_rates_freight: [],
                                          amounts_without_gst: [],
                                          amounts_with_gst: []
                                        };
                                      }
                                      acc[key].quantities.push(diameter.diameter_quantity);
                                      acc[key].unit_rates.push(diameter.unit_rate);
                                      acc[key].unit_rates_freight.push(diameter.unit_rate_of_freight);
                                      acc[key].amounts_without_gst.push(diameter.amount_without_gst);
                                      acc[key].amounts_with_gst.push(diameter.amount_with_gst);
                                      return acc;
                                    }, {});

                                    return Object.values(groupedByDiameter).map((groupedItem) => {
                                  return {
                                        materialName: groupedItem.materialName,
                                        quantity: groupedItem.quantities.reduce((sum, qty) => sum + qty, 0),
                                        uom: groupedItem.uom,
                                        diameter: groupedItem.diameter,
                                        r_unit_price: groupedItem.unit_rates[0], 
                                        r_unit_price_freight: groupedItem.unit_rates_freight[0], 
                                        r_total_price: groupedItem.amounts_without_gst.reduce((sum, amount) => sum + amount, 0),
                                        total_amount_with_gst: groupedItem.amounts_with_gst.reduce((sum, amount) => sum + amount, 0),
                                      };
                                    });
                                  } else {
                                    return [{
                                    materialName: item1.bid_material_type_name,
                                    quantity: item1.bid_material_quantity,
                                    uom: item1.bid_uom,
                                      diameter: null,
                                    r_unit_price: item1.unit_rate,
                                    r_unit_price_freight: item1.unit_rate_of_freight,
                                    r_total_price: item1.amount_without_gst,
                                      total_amount_with_gst: item1.amount_with_gst,
                                    }];
                                  }
                                }
                              ),
                            };
                          }),
                        };
                      }
                    ),
                  };
                });

                setComparativesRFQ(tableData);

                const poTotalAmount = responseData?.reduce((total, item) => {
                  const cityTotal = item.vendor_city_total.reduce(
                    (acc, vendor) => acc + vendor.amount_with_gst,
                    0
                  );
                  return total + cityTotal;
                }, 0);

                setPoTotalAmount(poTotalAmount);

                setapiloading(false);
              } else {
                ErrorNotificationMsg(t("Error in Comparatives"));
                setapiloading(false);
              }
            })
            .catch((response) => {
              ErrorNotificationMsg(response.data.message);
            });
        }
      } catch (error) {
        setapiloading(false);
      }
    };
    getVendorBidRFQ();
  }, [action]);

  const data = comparativesRFQ?.flatMap((item, index) => {
    const citySubTotal =
      item.citySubTotal.toLocaleString("en-IN", { maximumFractionDigits: 0 }) ||
      0;
    return item.comparative.flatMap((comparative, compIndex) => {
      const siteSubTotal = comparative.siteSubTotal || 0;
      const siteSubTotalWithGst =
        comparative.siteSubTotalWithGST?.toLocaleString("en-IN", {
          maximumFractionDigits: 0,
        }) || 0;

      return comparative.vendorWise.flatMap((vendor, vendorIndex) => {
        return vendor.siteLocations.flatMap((location, locationIndex) => {
          return [
            {
              key: `${index}-${compIndex}-${vendorIndex}-${locationIndex}`,
              "Sr.No":
                locationIndex === 0 && compIndex === 0 ? `${index + 1}` : null,
              City:
                locationIndex === 0 && compIndex === 0
                  ? `${item.cityName}`
                  : null,
              "Site Name":
                locationIndex === 0 ? `${comparative.siteName}` : null,
              "Vendor Name":
                locationIndex === 0 ? vendor.vendorName || "" : null,
              Items: locationIndex === 0 || 
                     (locationIndex > 0 && 
                      vendor.siteLocations[locationIndex - 1]?.materialName !== location.materialName) 
                     ? `${location.materialName || ""}` : null,
              Quantity: `${location.quantity || ""}`,
              UOM: `${location.uom || ""}`,
              ...(hasDiameter && { "Diameter": location.diameter ? `${location.diameter} MM` : "" }),
              "Unit Rate": `${`\u20B9 ${
                location.r_unit_price?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) || 0
              }`}`,
              "Unit Rate Fright": `${`\u20B9 ${
                location.r_unit_price_freight?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) || 0
              }`}`,
              "Total Amount": `${`\u20B9 ${
                location.r_total_price?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) || 0
              }`}`,
              TotalAmountGST: `${`\u20B9 ${
                location.total_amount_with_gst.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) || 0
              }`}`,
            },
            locationIndex === vendor.siteLocations.length - 1 && {
              key: `${index}-${compIndex}-${vendorIndex}-SubTotal`,
              "Site Name": "Sub-Total",
              "Total Amount": (
                <div className="subtotal1">
                  {`\u20B9 ${siteSubTotal.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}`}
                </div>
              ),
              TotalAmountGST: (
                <div className="subtotal1">
                  {`\u20B9 ${siteSubTotalWithGst.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}`}
                </div>
              ),
            },
            locationIndex === vendor.siteLocations.length - 1 &&
              compIndex === item.comparative.length - 1 && {
                key: `${index}-CitySubTotal`,
                "Site Name": "City-sub-Total",
                "Total Amount": (
                  <div className="citytotall">
                    {`\u20B9 ${item.citySubTotalWithoutGST.toLocaleString(
                      "en-IN",
                      { maximumFractionDigits: 0 }
                    )}`}
                  </div>
                ),
                TotalAmountGST: (
                  <div className="citytotall">
                    {`\u20B9 ${citySubTotal.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                  </div>
                ),
              },
          ].filter(Boolean);
        });
      });
    });
  });
  

  const columns = [
    {
      title: "Sr.",
      dataIndex: "Sr.No",
    },
    {
      title: "City",
      dataIndex: "City",
    },
    {
      title: "Site",
      dataIndex: "Site Name",
      render: (text, record) => {
        return text === "Sub-Total" ? "Sub Total" : text === "City-sub-Total" ? "City Total" : text
      }
    },
    {
      title: "Vendor",
      dataIndex: "Vendor Name",
      width: 200,
    },

    {
      title: "Items",
      dataIndex: "Items",
    },
        hasDiameter && {
      title: "Diameter",
      dataIndex: "Diameter",
      align: "center",
    },
    {
      title: "Qty.",
      dataIndex: "Quantity",
      align: "right",
    },
    {
      title: "UoM.",
      dataIndex: "UOM",
      render: (text, record) => {
        return <span>{text === "Cubic Meter" ? "Cu. Mtr." : text}</span>;
      },
    },

    {
      title: "Unit Rate",
      dataIndex: "Unit Rate",
      align: "right",
    },
    isFreight && {
      title: "Unit Rate Of Fright",
      dataIndex: "Unit Rate Fright",
      align: "right",
    },
    {
      title: "Total Amount Without GST",
      dataIndex: "Total Amount",
      align: "right",
      render: (text, record) => {
        if (record["Site Name"] === "Sub-Total") {
          return <div>{record["Total Amount"]}</div>;
        } else if (record["Site Name"] === "City-sub-Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["Total Amount"]}</div>
          );
        } else {
          return (
            <div style={{ marginRight: "10px" }}>{record["Total Amount"]}</div>
          );
        }
      },
    },
    {
      title: "Total Amount With GST",
      dataIndex: "TotalAmountGST",
      align: "right",
      render: (text, record) => {
        if (record["Site Name"] === "Sub-Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["TotalAmountGST"]}</div>
          );
        } else if (record["Site Name"] === "City-sub-Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["TotalAmountGST"]}</div>
          );
        } else {
          return (
            <div style={{ marginRight: "10px" }}>
              {record["TotalAmountGST"]}
            </div>
          );
        }
      },
    },
  ].filter(Boolean);


  if (action === "ApproveandIssueOrder") {
    return (
      <section
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin spinning={apiLoading} />
      </section>
    );
  } else {
return (
      <>
        <Spin spinning={apiLoading}>
          <div className="invoice-container">
            <div className="ListingTopBar">
              <div className="pagenamewrap">
                <div className="pagename">
                  <h3>Approve Purchase Order</h3>

                  <Breadcrumb className="Breadcrumb-Sec">
                    <Breadcrumb.Item>Approval</Breadcrumb.Item>
                    <Breadcrumb.Item>Approve Purchase Order</Breadcrumb.Item>
                  </Breadcrumb>
                </div>
              </div>
            </div>

            <section className="grid-sec mt-5">
              <div className="PR-body">
                <div ref={pdfContainerRef}>
                  <div className="rgq-num-wrap">
                    <h5 className="rfq-number new">
                      RFQ Number : <span>{rfqNumber}</span>
                    </h5>
                  </div>
                  <Spin spinning={apiLoading}>
                    <div>
                    {orderData.length !== 0 && (
                    <div style={{ fontFamily: "Arial, sans-serif", fontSize: "13px", color: "#333", lineHeight: "0.9" }}>
                      <h4 style={{ marginLeft: "10px", borderBottom: "1px solid #bcb6b6" }}>Purchase Order</h4>
                      <div style={{ display: "flex", borderBottom: "1px solid #bcb6b6" }}>
                        <div style={{ width: "33.33%", padding: "10px", boxSizing: "border-box" }}>
                          <h4 style={{ marginTop: 0 }}>Buyer Details</h4>
                          <p><strong>Name:</strong> {orderData.company_details?.name}</p>
                          <p><strong>Mobile:</strong> {orderData.company_details?.phone_number}</p>
                          <p><strong>Email:</strong> {orderData.company_details?.email}</p>
                          <p><strong>Address:</strong> {`${orderData.company_details?.registered_business_address_building}, ${orderData.company_details?.registered_business_address_area}, ${orderData.company_details?.registered_business_address_city}`}</p>
                          <p><strong>GSTN:</strong> {orderData.company_details?.gst_number}</p>
                        </div>
                        <div style={{ width: "33.33%", padding: "10px", boxSizing: "border-box" }}>
                          <h4 style={{ marginTop: 0 }}>PO Details</h4>
                          <p><strong>PO Number:</strong> {orderData.po_number}</p>
                          <p><strong>PO Date:</strong> {orderData.po_created_date ? moment(orderData.po_created_date, "DD-MM-YYYY").format("DD/MM/YYYY") : ""}</p>
                          <p><strong>Payment Terms:</strong> {orderData.payment_terms}</p>
                          <p><strong>Delivery Date:</strong> {orderData?.purchase_order_city_details?.[0]?.purchase_order_site_details?.[0]?.po_vendor_detail?.[0]?.po_material_detail?.[0]?.delivery_date || "N/A"}</p>
                        </div>
                        <div style={{ width: "33.33%", textAlign: "center", padding: "10px", boxSizing: "border-box" }}>
                          <img src={orderData.company_details?.company_logo || newLogo} alt="Company Logo" style={{ height: "80px", maxWidth: "100%", objectFit: "contain" }} />
                        </div>
                      </div>
                      <div style={{ display: "flex", borderBottom: "1px solid #bcb6b6" }}>
                        <div style={{ width: "33.33%", padding: "10px", boxSizing: "border-box" }}>
                          <h4 style={{ marginTop: 0 }}>Vendor Details</h4>
                          <p><strong>Name:</strong> {orderData.vendor_details?.name}</p>
                          <p><strong>Mobile:</strong> {orderData.vendor_details?.phone_number}</p>
                          <p><strong>Email:</strong> {orderData.vendor_details?.email}</p>
                          <p><strong>Address:</strong> {`${orderData.vendor_details?.registered_business_address_building}, ${orderData.vendor_details?.registered_business_address_area}, ${orderData.vendor_details?.registered_business_address_city}`}</p>
                          <p><strong>GSTN:</strong> {orderData.vendor_details?.gst_number}</p>
                        </div>
                        <div style={{ width: "33.33%", padding: "10px", boxSizing: "border-box" }}>
                          <h4 style={{ marginTop: 0 }}>Billing Details</h4>
                          <p><strong>Address:</strong> {`${orderData.site_location?.billing_details?.billing_address_line_1}, ${orderData.site_location?.billing_details?.billing_address_line_2}, ${orderData.site_location?.billing_details?.billing_city}, ${orderData.site_location?.billing_details?.billing_state}, ${orderData.site_location?.billing_details?.billing_pincode}`}</p>
                          <p><strong>GSTN:</strong> {orderData.site_location?.gst_number}</p>
                        </div>
                        <div style={{ width: "33.33%", padding: "10px", boxSizing: "border-box" }}>
                          <h4 style={{ marginTop: 0 }}>Shipping Details</h4>
                          <p><strong>Address:</strong> {`${orderData.site_location?.shipping_details?.shipping_address_line_1}, ${orderData.site_location?.shipping_details?.shipping_address_line_2}, ${orderData.site_location?.shipping_details?.shipping_city}, ${orderData.site_location?.shipping_details?.shipping_state}, ${orderData.site_location?.shipping_details?.shipping_pincode}`}</p>
                          <p><strong>GSTN:</strong> {orderData.site_location?.gst_number}</p>
                        </div>
                      </div>
                    </div>
                  )}

                      <Table
                        className="scroll5"
                        // dataSource={comparativesRFQ}
                        dataSource={data}
                        bordered
                        // scroll={{
                        //   x: 1500,
                        // }}
                        size="middle"
                        pagination={false}
                        columns={columns}
                      />
                    </div>
                  </Spin>

                </div>
              </div>
            </section>
            <div style={{marginLeft:'40px'}}>
              <div className="TotalAMT">
                <label>Total Amount: </label>

                <div
                  className="citytotal"
                  style={{ width: "140px", textAlign: "end" }}
                >
                  ₹{" "}
                  {poTotalAmount
                    ? poTotalAmount.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })
                    : 0}
                </div>
              </div>
              <>
                <div className="btnwrp2" style={{ paddingTop: "16px" }}>
                  <ButtonField
                    type="primary"
                    className="SaveGradiantBtn w-auto"
                    label={t("Accept Order")}
                    loading={btnLoading}
                    onClick={handleDirectRelease}
                  />
                  <ButtonField
                    type="primary"
                    className="SaveGradiantBtn w-auto"
                    label={t("Reject")}
                    loading={btnLoading2}
                    onClick={handleReject}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "5px",
                  }}
                >
                  <Input
                    placeholder="Write Remark Here If Any"
                    className="InputTotal"
                    style={{ marginTop: "11px", maxWidth: "600px" }}
                  />
                </div>
              </>
            </div>
          </div>
        </Spin>
      </>
    );
  }
};

export default VendorPoApproveReject;
